import { jsx as _jsx } from "react/jsx-runtime";
import { _className, LL_H_C } from '@nu-art/thunderstorm-frontend/index';
export const renderDpIcons = (associatedDps, maxDpCount, onHover) => {
    let inStyle = {};
    if (maxDpCount > 0)
        inStyle = { width: calculateDpIconsContainerWidth(maxDpCount) };
    const className = _className('dp_container', associatedDps.length === 0 ? 'empty' : undefined);
    return _jsx(LL_H_C, { className: className, style: inStyle, onMouseLeave: e => onHover?.(e, 'leave'), onMouseEnter: e => onHover?.(e, 'enter'), children: associatedDps.length > 0 && associatedDps.map(item => renderDpIcon(item)) });
};
export const renderDpIcon = (dp) => {
    return _jsx("div", { className: 'dp-icon', children: dp.initials }, dp._id);
};
export const calculateDpIconsContainerWidth = (maxDpCount) => {
    const singleSize = 36;
    return 2 + maxDpCount * (singleSize + 2);
};
//# sourceMappingURL=Renderer_Initials.js.map